export default __webpack_public_path__ + "static/media/img2.f5e72390.jpg";